import { render, staticRenderFns } from "./base-card.component.vue?vue&type=template&id=3a0acb38"
import script from "./base-card.component.ts?vue&type=script&lang=ts&external"
export * from "./base-card.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports